import { render, staticRenderFns } from "./RemoteTargetTable.vue?vue&type=template&id=c6c873ba&"
import script from "./RemoteTargetTable.vue?vue&type=script&lang=ts&"
export * from "./RemoteTargetTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports